const NO_OF_EMPLOYEES = [
  { value: '1 to 9', label: '1 to 9' },
  { value: '10 to 49', label: '10 to 49' },
  { value: '50 to 99', label: '50 to 99' },
  { value: '100 to 249', label: '100 to 249' },
  { value: '250 or more', label: '250 or more' }
];

export default NO_OF_EMPLOYEES;
